import Vue from 'vue';
import moment from 'moment-timezone';

const DATE_FORMAT = 'YYYY-MM-DD';

Vue.mixin({
  methods: {
    async getRandomCoupon() {
      try {
        const cart = localStorage.getItem('cart')
            ? localStorage.getItem('cart') : null;

        const response = await this.axios.post('v2/coupon', {cart});

        if (response && response.data && response.data.success) {
          const coupon = response.data.data;

          await this.$store.dispatch('SET_COUPON', coupon);
          this.showCouponBanner();
        } else {
          await this.$store.dispatch('SET_COUPON', null);

          if (document.getElementsByClassName('b-toast-coupon').length) {
            this.$bvToast.hide();
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }

    },
    showRandomCouponBanner() {
      if (this.coupon) {
        this.showCouponBanner();
      } else {
        this.getRandomCoupon();
      }
    },
    showCouponBanner() {
      if (this.coupon && !document.getElementsByClassName('b-toast-coupon').length) {
        const h = this.$createElement;
        const vNodesMsg = h('coupon-banner',
        );

        this.$root.$bvToast.toast(vNodesMsg, {
          variant: 'coupon',
          toaster: 'b-toaster-bottom-center',
          noAutoHide: true,
        });
      }
    },
    getCouponTime(date) {
      const result = moment(date, DATE_FORMAT).add(1, 'day').
          diff(moment(), 'seconds');
      return result && result > 0 ? result * 1000 : 0;
    },
    getCouponDate(date) {
      return moment(date).format('DD.MM.YYYY');
    }
  },
});

